import { BRAND } from "@presentation/brand";

/** Copies the brand colors from the shared BRAND config into CSS variables. */
export function applyBrand(root: HTMLElement = document.documentElement): void {
  const vars: Record<string, string> = {
    "--brand-primary": BRAND.colors.primary,
    "--brand-primary-contrast": BRAND.colors.primaryContrast,
    "--brand-accent": BRAND.colors.accent,
    "--color-text": BRAND.colors.text,
    "--color-muted": BRAND.colors.muted,
    "--color-border": BRAND.colors.border,
  };
  for (const [name, value] of Object.entries(vars)) root.style.setProperty(name, value);
  document.title = BRAND.productName;
}
